export const ID_APP = 'molecule';
export const ID_ACTIVITY_BAR = 'activityBar';
export const ID_MENU_BAR = 'menuBar';
export const ID_SIDE_BAR = 'sidebar';
export const ID_EXPLORER = 'explorer';
export const ID_STATUS_BAR = 'statusBar';
export const ID_FOLDER_TREE = 'folderTree';
export const ID_EDITOR_TREE = 'editorTree';
